import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { GenderModel, PayServiceTypeEnum, PayServiceTypeModel, XpressUserProfile, XpressUserRoleEnum } from 'app/models';
import { AppDataService } from 'app/services';

@Component({
  selector: 'edit-profile-details',
  templateUrl: './edit-profile-details.component.html',
  styleUrls: ['./edit-profile-details.component.scss']
})
export class EditProfileDetailsComponent implements OnInit {

  @Input() public editDialog: boolean = false;
  @Input() public profile: XpressUserProfile = new XpressUserProfile();
  @Output() public hideProfileModal = new EventEmitter();
  @Output() public updatingUserProfile = new EventEmitter<XpressUserProfile>();
  @Input() public temporaryProfile: XpressUserProfile = new XpressUserProfile();

  public menuItems: MenuItem[] = [
  ];

  public activeItem: MenuItem = this.menuItems[0];
  genderList = GenderModel.GenderList;
  bankList = PayServiceTypeModel.PayServiceTypeList.filter(x => x.value === PayServiceTypeEnum.BaUbp
    || x.value === PayServiceTypeEnum.BaBpi || x.value === PayServiceTypeEnum.BaCb || x.value === PayServiceTypeEnum.BaPnb
    || x.value === PayServiceTypeEnum.BaEwb);

  editDetailsForm: FormGroup = new FormGroup({
  });
  businessDetailsForm: FormGroup = new FormGroup({
  });

  public avatarHover = false;
  tempProfile: XpressUserProfile = new XpressUserProfile();


  constructor(
        private formBuilder: FormBuilder,
        private appData: AppDataService,
        private messageService: MessageService
      ) {
  }

  ngOnInit(): void {
    this.initializeEditForm(this.temporaryProfile.AccountName ? this.temporaryProfile : this.profile);
    this.initializeBusinessForm(this.temporaryProfile.AccountName ? this.temporaryProfile : this.profile);

    if(this.isOperator()){
        this.menuItems.push({
          id: EditProfileTab.Details,
          label: 'Details'
        },
        {
          id: EditProfileTab.BusinessDetails,
          label: 'Business Details'
        });
      } else {
        this.menuItems.push(
        {
          id: EditProfileTab.Details,
          label: 'Details'
        });
      }
      this.activeItem = this.menuItems[0];
  }

  public get companyName() {
    return this.editDetailsForm.get('CompanyName');
  }

  public get firstName() {
    return this.editDetailsForm.get('FirstName');
  }

  public get lastName() {
    return this.editDetailsForm.get('LastName');
  }

  public get email() {
    return this.editDetailsForm.get('Email');
  }

  public get address() {
    return this.editDetailsForm.get('Address');
  }

  public get gender() {
    return this.editDetailsForm.get('Gender');
  }

  public get birthDate() {
    return this.editDetailsForm.get('BirthDate');
  }

  public get TaxNumber() {
    return this.businessDetailsForm.get('TaxNumber');
  }

  public get AccountName() {
    return this.businessDetailsForm.get('AccountName');
  }

  public get AccountNumber() {
    return this.businessDetailsForm.get('AccountNumber');
  }

  public get BankTypeId() {
    return this.businessDetailsForm.get('BankTypeId');
  }

  private initializeEditForm(profile: XpressUserProfile): void {
    this.editDetailsForm = this.formBuilder.group({
      CompanyName: [profile.CompanyName, [Validators.required]],
      FirstName: [profile.FirstName, [Validators.required]],
      LastName: [profile.LastName, [Validators.required]],
      Email: [profile.Email, [Validators.required, Validators.email]],
      Address: [profile.Address, [Validators.required]],
      Gender: [profile.Gender, [Validators.required]],
      BirthDate: [profile.BirthDate, [Validators.required]]
    });
  }

  private initializeBusinessForm(profile: XpressUserProfile): void {
    this.businessDetailsForm = this.formBuilder.group({
      TaxNumber: [profile.TaxNumber, [Validators.required, Validators.pattern('^(?![-])(?!.*[-]$)(?!.*[-]{2})[0-9-]{9,12}$')]],
      AccountName: [profile.AccountName, [Validators.required]],
      AccountNumber: [profile.AccountNumber, [Validators.required]],
      BankTypeId: [profile.BankTypeId, [Validators.required]]
    });
  }

  public handleInputProfileImgClick(id: string): void {
    document.getElementById(id)?.click();
  }

  public handleInputProfileImgChange(event: Event) {
    const target = event.target as HTMLInputElement;

    let file: File | null = null;
    if (target.files) {
        file = target.files[0];
    }

    if (!file) {
        return;
    }

    // Chech max file size 2MB
    if (file.size > 2097152) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
        return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
        if (e?.target?.result) {
            // Base64 string
            this.profile.ImageData = e.target.result.toString();
            this.profile.ImageUrl = e.target.result.toString();
        }
    };

    reader.readAsDataURL(file);
  }

  public onActiveItemChange(item: any): void {
    this.activeItem = item;
  }

  isOperator() {
      return +this.appData.authData.roleId === XpressUserRoleEnum.Operator;
  }

  public updateUserProfile(){
    this.profile.CompanyName = this.editDetailsForm.value.CompanyName;
    this.profile.FirstName = this.editDetailsForm.value.FirstName;
    this.profile.LastName = this.editDetailsForm.value.LastName;
    this.profile.Email = this.editDetailsForm.value.Email;
    this.profile.Address = this.editDetailsForm.value.Address;
    this.profile.Gender = this.editDetailsForm.value.Gender;
    this.profile.BirthDate = this.editDetailsForm.value.BirthDate;
    this.profile.TaxNumber = this.businessDetailsForm.value.TaxNumber;
    this.profile.AccountName = this.businessDetailsForm.value.AccountName;
    this.profile.AccountNumber = this.businessDetailsForm.value.AccountNumber;
    this.profile.BankTypeId = this.businessDetailsForm.value.BankTypeId;
    this.updatingUserProfile.emit(this.profile);
  }

  public discardChanges(): void {
    this.tempProfile.CompanyName = this.editDetailsForm.value.CompanyName;
    this.tempProfile.FirstName = this.editDetailsForm.value.FirstName;
    this.tempProfile.LastName = this.editDetailsForm.value.LastName;
    this.tempProfile.Email = this.editDetailsForm.value.Email;
    this.tempProfile.Address = this.editDetailsForm.value.Address;
    this.tempProfile.Gender = this.editDetailsForm.value.Gender;
    this.tempProfile.BirthDate = this.editDetailsForm.value.BirthDate;
    this.tempProfile.TaxNumber = this.businessDetailsForm.value.TaxNumber;
    this.tempProfile.AccountName = this.businessDetailsForm.value.AccountName;
    this.tempProfile.AccountNumber = this.businessDetailsForm.value.AccountNumber;
    this.tempProfile.BankTypeId = this.businessDetailsForm.value.BankTypeId;
    this.editDialog = false;
    this.hideProfileModal.emit(this.tempProfile);
  }

}

export enum EditProfileTab {
  Details = '1',
  BusinessDetails = '2'
}
